import React from "react";
import { create } from "zustand";
import { ProductsAPI } from "../Helpers/ConfigProvider";

const normalizeErrors = (errorData) => {
  if (Array.isArray(errorData?.Errors)) return errorData.Errors;
  if (Array.isArray(errorData)) return errorData;
  if (errorData?.message) {
    return [{ PropertyName: "", ErrorMessage: errorData.message }];
  }
  return [{ PropertyName: "", ErrorMessage: "Failed to send contact form" }];
};

const useContactStore = create((set, get) => ({
  contact: {},
  loading: false,
  sendingMessage: false,
  sendingChristmas: false,
  errors: [],
  getContactDetails: async () => {
    try {
      if (Object.keys(get().contact).length !== 0) {
        return get().contact;
      }

      const response = await fetch(`${ProductsAPI}/Contact`);
      const data = await response.json();
      set({ contact: data });
      return data;
    } catch (error) {
      console.error("Failed to fetch contact details:", error);
      return null;
    }
  },
  sendContactForm: async (formData) => {
    if (get().sendingMessage) {
      return; // Prevent multiple submissions
    }
    set({ sendingMessage: true, errors: [] });
    try {
      const response = await fetch(`${ProductsAPI}/Contact/Message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      set({ sendingMessage: false });
      if (!response.ok) {
        const errorData = await response.json();

        if (response.status === 400) {
          if (errorData?.Errors) {
            if (
              Array.isArray(errorData?.Errors) &&
              errorData.Errors.length > 0
            ) {
              set({ errors: errorData.Errors });
            } else {
              set({
                errors: [
                  {
                    PropertyName: "",
                    ErrorMessage: "Failed to send contact form",
                  },
                ],
              });
            }
            return false;
          }
        } else {
          set({ errors: errorData || ["Failed to send contact form"] });
        }
        return false;
      }
      return true;
    } catch (error) {
      console.error("Failed to send contact form:", error);
      set({ sendingMessage: false });
      return false;
    }
  },
  sendGetChristmasSortedForm: async (formData) => {
    if (get().sendingChristmas) {
      return; // Prevent multiple submissions
    }
    set({ sendingChristmas: true, errors: [] });
    try {
      const response = await fetch(`${ProductsAPI}/Contact/GetChristmasSorted`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      set({ sendingChristmas: false });
       if (!response.ok) {
        const errorData = await response.json();

        if (response.status === 400) {
          if (errorData?.Errors) {
            if (
              Array.isArray(errorData?.Errors) &&
              errorData.Errors.length > 0
            ) {
              set({ errors: errorData.Errors });
            } else {
              set({
                errors: [
                  {
                    PropertyName: "",
                    ErrorMessage: "Failed to send reservation form",
                  },
                ],
              });
            }
            return false;
          }
        } else {
          set({ errors: errorData || ["Failed to send reservation form"] });
        }
        return false;
      }
      return true;
    } catch (error) {
      console.error("Failed to send reservation form:", error);
      set({ sendingChristmas: false });
      return false;
    }
  },
}));

export default useContactStore;
